import { render, staticRenderFns } from "./make-disbursement.vue?vue&type=template&id=6c036e9c&scoped=true&"
import script from "./make-disbursement.vue?vue&type=script&lang=js&"
export * from "./make-disbursement.vue?vue&type=script&lang=js&"
import style0 from "./make-disbursement.vue?vue&type=style&index=0&id=6c036e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c036e9c",
  null
  
)

export default component.exports